import { Subscription } from 'rxjs';
import {  Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
    selector: 'app-product-details',
    templateUrl: './product-detail-filter-modal.component.html',
    standalone: false
})

export class ProductDetailFilterModalComponent implements OnInit {
    //#region properties
    productDetails: any;
    fromPage: string | null = null;
    subscription: Subscription;
    //#endregion

    //#region Constructor
    constructor(
        private _router: Router,
        public activeModal: NgbActiveModal,
    ) { }
    //#endregion

    //#region Methods
    ngOnInit() {
        const preloadedData = this.productDetails;
        if (preloadedData) {
            this.productDetails = preloadedData;
        } else {
            this._router.navigate(['product-inventory/gold-inventory']);
        }


    }

    //#region Methods

    createNewSalesEntry() {
        const queryParams: any = {};
        if (this.productDetails.id) {
            queryParams.id = this.productDetails.id;
        }
        this._router.navigate(
            ['product-inventory/new-sales-entry'],
            { queryParams }
        );
        this.activeModal.close('navigate');
    }

    cancelPopup() {
        this.activeModal.close('cancel');
    }

    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }
    //#endregion
}
